import React from "react";
import './Team.css';

export default function () {

    return (

        <>

            <section className="sec-3-Team pb-md-5">   {/*section 3 Team start start */}

                <div className="container">
                    <h2 className="text-center fw-bold pt-4">MEET CRYSTAL TEAM</h2>

                    <p className="pt-3 text-center  ">Mauris mattis vitae libero eget iaculis. Donec et augue quis quam porttitor consectetur ut nec <br />sem. Integer sagittis viverra quam quis ultricies. Aenean risus nisl, consequat at nunc id, tincidunt <br />tristique mauris</p>

                    <div className="row pt-3">
                        <div className="col-6 col-md-3">

                            <figure>
                                <img src="/images/team-img-1.jpg" alt="" className="img-fluid" />
                                <figcaption className="fig-cap">
                                    <h2 className="text-center">TRACY</h2>
                                    <h4 className="text-color text-center">DESIGNER</h4>


                                </figcaption>
                            </figure>

                        </div>

                        <div className="col-6 col-md-3">

                            <figure>
                                <img src="/images/team-img-2.jpg" alt="" className="img-fluid" />
                                <figcaption className="fig-cap">
                                    <h2 className="text-center">MARY</h2>
                                    <h4 className="text-color text-center">DEVELOPER</h4>
                                </figcaption>
                            </figure>

                        </div>

                        <div className="col-6 col-md-3">

                            <figure>
                                <img src="/images/team-img-3.jpg" alt="" className="img-fluid" />
                                <figcaption className="fig-cap">
                                    <h2 className="text-center">JULIA</h2>
                                    <h4 className="text-color text-center">DIRECTOR</h4>
                                </figcaption>
                            </figure>

                        </div>

                        <div className="col-6 col-md-3 ">

                            <figure>
                                <img src="/images/team-img-4.jpg" alt="" className="img-fluid" />
                                <figcaption className="fig-cap">
                                    <h2 className="text-center">LINDA</h2>
                                    <h4 className="text-color text-center">MANAGER</h4>
                                </figcaption>
                            </figure>

                        </div>

                    </div>

                </div>

            </section>  {/*section 3 Team start Ends */}

        </>
    )

}